import servicesUtils from "../../../utils/servicesUtils";
var createReminderNote = function createReminderNote(patientUid, reminderId, payload) {
  return servicesUtils.postService("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/notes/create/"), payload);
};
export default createReminderNote;